export function ErrorPage() {
	return (
		<div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

			<div className="card" style={{ borderRadius: "8px 8px 0 0", overflow: "hidden", boxShadow: "0 2px 10px rgba(0,0,0,0.1)" }}>
				<div style={{ background: "#B95462", color: "#fff", padding: "20px 40px", }}>
					<h1 style={{ margin: 0 }}>Error no controlado en la aplicación.</h1>
				</div>

				<div style={{ padding: "20px 40px", fontSize: 18, color: "#333", maxWidth: 600, textAlign: "center" }}>
					Por favor, vuelva a la refresque la página y contacte con el administrador del sistema si el problema persiste.
				</div>
				<div style={{ textAlign: "center", padding: "20px" }}>

					<button style={{ background: "none", border: "solid 1px #333", padding: "10px 20px", borderRadius: "4px" }} onClick={() => window.location.reload()} type="button">
						<i className="fa fa-refresh" style={{ fontSize: 40 }} />
					</button>
				</div>
			</div>
		</div>
	);
}
